export default __webpack_public_path__ + "static/media/signUpRightImg.03a8535d.svg";